export default "__VITE_ASSET__D2Xhb8ku__"